export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/Google_Maps_pin.194c4266.svg","height":59,"width":43,"blurWidth":0,"blurHeight":0};